import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Component({
  selector: 'bom-confirm-changes',
  templateUrl: './confirm-changes.component.html',
  styleUrls: ['./confirm-changes.component.scss'],
})
export class ConfirmChangesComponent implements OnInit {
  @Input()
  isDiscardPendingChangesModalOpen$: Subject<boolean>;
  @Input()
  trapping$ = new BehaviorSubject<boolean>(true);
  @Input()
  pageName: string;

  @Output()
  discardChanges = new EventEmitter<boolean>();

  constructor() {}

  ngOnInit(): void {}
}
